module.exports = __webpack_public_path__ + "files/e741966acf0e855d423111a718e37a54.png";